import React, { useState } from "react";
import "../../Assets/css/PrescriptionDetails.css";
import useBookingApp from "../../hooks/useBookingApp";
import { updatePrescription, setPrescriptionStatusMessage } from "../../dispatchers/consentDispatchers";
import { useNavigate } from "react-router-dom";

function PrescriptionDetails() {
    const { consentState } = useBookingApp();
    const { currentServiceId, rescheduleBookingModel } = consentState || {};
    const [notes, setNotes] = useState("");
    const [loadingSlots, setLoadingSlots] = useState(false);
    const navigate = useNavigate();

    const handleButtonClick = async (status) => {
        setLoadingSlots(true);
        const updatedPrescriptionModel = {
            ...rescheduleBookingModel,
            prescriptionStatus: status,
            notes: notes,
        };

        updatePrescription(updatedPrescriptionModel).then((data) => {
            if (data) {
                setPrescriptionStatusMessage(
                    status === 1
                        ? "Prescription has been successfully dispensed."
                        : "Prescription has been marked as not dispensed."
                );
                navigate(`/StatusNotification`);
            } else {
                setPrescriptionStatusMessage("Failed to update prescription. Please try again.");
            }
            setLoadingSlots(false);
        });
    };


    return (
        <div className="prescription-detail-container">
            {new Date(rescheduleBookingModel?.prescriptionExpiryDate) < new Date() && (
                <div className="expire-label">
                    <span>This prescription is Expired</span>
                </div>
            )}
            <div className="prescription-view-container">
                <img src={rescheduleBookingModel?.prescriptionBase64} alt="Captured Prescription" />
            </div>

            {rescheduleBookingModel?.prescriptionStatus === 0 &&
                new Date(rescheduleBookingModel?.prescriptionExpiryDate) > new Date() ? (
                <div>
                    <div className="prescription-notes-area">
                        <label htmlFor="prescription-notes">Add Notes:</label>
                        <textarea
                            id="prescription-notes"
                            className="prescription-textarea"
                            placeholder="Write your notes here..."
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                        ></textarea>
                    </div>
                    <div className="prescription-footer">
                        {loadingSlots ? (
                            <div className="loading-dots">
                                <span>Updating</span>
                                <span className="loading">.</span>
                                <span className="loading">.</span>
                                <span className="loading">.</span>
                            </div>
                        ) : (
                            <>
                                <button className="nhsuk-button dispense" onClick={() => handleButtonClick(1)}>
                                    Dispense
                                </button>
                                <button className="nhsuk-button not-dispense" onClick={() => handleButtonClick(3)}>
                                    Not Dispense
                                </button>
                            </>
                        )}
                    </div>
                </div>
            ) : (
                <div></div>
            )}

        </div>
    );
}

export default PrescriptionDetails;
